<template>
  <div class="product-content-dialog__content" @click="$emit('close')">
    <template v-if="content">
      <img v-if="contentType === 'image'" :src="content" />
      <iframe
        v-else-if="contentType === 'youtube'"
        width="720"
        height="405"
        :src="`https://youtube.com/embed/${content}`"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </template>
  </div>
</template>
<script>
export default {
  name: 'ProductContent',
  props: {
    contentType: {
      type: String,
      required: true
    },
    content: {
      type: String,
      default: null
    }
  },
  data () {
    return {}
  }
}
</script>
<style lang="css" scoped>
.product-content-dialog__content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product-content-dialog img,
.product-content-dialog iframe {
  max-width: 90%;
  max-height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/preview/elements/ProductContent.vue